
// document.addEventListener('DOMContentLoaded', function() {
//   const descriptions = document.querySelectorAll('.collapsible-description');
  
//   descriptions.forEach(desc => {
//     const content = desc.querySelector('.description-content');
//     const toggle = desc.querySelector('.description-toggle');
    

//     if (content.scrollHeight > 120) {
//       toggle.style.display = 'block';
//     }
//   });
// });

// function toggleDescription(button) {
//   const container = button.closest('.collapsible-description');
//   const showMore = button.querySelector('.show-more');
//   const showLess = button.querySelector('.show-less');
  
//   container.classList.toggle('expanded');
  
//   if (container.classList.contains('expanded')) {
//     showMore.style.display = 'none';
//     showLess.style.display = 'inline';
//   } else {
//     showMore.style.display = 'inline';
//     showLess.style.display = 'none';
//   }
// }

// Collapsible Description Functionality
document.addEventListener('DOMContentLoaded', function() {
  const descriptions = document.querySelectorAll('.collapsible-description');
  
  descriptions.forEach(desc => {
    const content = desc.querySelector('.description-content');
    const toggle = desc.querySelector('.description-toggle');
    
    if (content.scrollHeight > 120) {
      toggle.style.display = 'block';
    }
  });
});

function toggleDescription(button) {
  const container = button.closest('.collapsible-description');
  const content = container.querySelector('.description-content');
  const showMore = button.querySelector('.show-more');
  const showLess = button.querySelector('.show-less');
  
  if (container.classList.contains('expanded')) {
    // Collapsing - scroll back to button first
    // button.scrollIntoView({ 
    //   behavior: 'smooth', 
    //   block: 'center' 
    // });
    
    setTimeout(() => {
      container.classList.remove('expanded');
      content.style.maxHeight = '120px';
      showMore.style.display = 'inline';
      showLess.style.display = 'none';
    }, 300);
    
  } else {
    container.classList.add('expanded');
    content.style.maxHeight = content.scrollHeight + 'px';
    showMore.style.display = 'none';
    showLess.style.display = 'inline';
  }
}